import nav from "./nav.json";
import page from "./pages.json";
import messages from "./messages.json";
import common from "./common.json";
import tobetranslated from "./tobetranslated.json";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  nav,
  page,
  messages,
  common,
  tobetranslated,
};
